import { ContentBlockFragment } from '@graphqlTypes/sitecore';
import { nonPageTracker } from '@src/adobe-launch/data-layer-provider';
import { TrackingEvent } from '@src/adobe-launch/types';
import { convertArticleInfo } from '@src/hooks/tracker/use-article-tracker';
import { JsBridge, SendPreferenceCRMData } from './js-bridge';

export class jsBridgeProxy extends JsBridge {
    constructor(private jsbridge: JsBridge) {
        super();
    }
    appCloseNativePIP(): void {
        this.jsbridge.appCloseNativePIP();
    }
    appShareUrl(url: string, contentBlock?: ContentBlockFragment | undefined): void {
        this.jsbridge.appShareUrl(url);
        const articleInfo = contentBlock ? convertArticleInfo(contentBlock) : undefined;
        nonPageTracker({ eventID: TrackingEvent.ArticleShare }, { article: articleInfo });
    }
    BetpickVideoBarShare(
        url: string,
        contentBlock?: ContentBlockFragment | undefined,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        trackerObj?: any
    ): void {
        this.jsbridge.appShareUrl(url);
        const articleInfo = contentBlock ? convertArticleInfo(contentBlock) : undefined;
        nonPageTracker(
            { eventID: TrackingEvent.BetpickVideoBarShare, ...trackerObj },
            { article: articleInfo }
        );
    }

    // appDirectTo(page: 'CouponList' | 'P-CardPage'): void {
    //     this.jsbridge.appDirectTo(page);
    // }
    appOpenExternalBrowser(url: string): void {
        this.jsbridge.appOpenExternalBrowser(url);
    }
    appGetLocalStorageDataRequest(): void {
        // console.log('call appGetLocalStorageDataRequest------jsBridge');
        this.jsbridge.appGetLocalStorageDataRequest();
    }
    appGetLocalStorageDataRequestAsync(): void {
        // console.log('call appGetLocalStorageDataRequestAsync------jsBridge');
        this.jsbridge.appGetLocalStorageDataRequestAsync();
    }
    appSetUiVisibility(ui: 'btnBack' | 'btnCalendar' | 'btnSkip', visable: boolean): void {
        // console.warn(`${ui}===============`, visable);
        this.jsbridge.appSetUiVisibility(ui, visable);
    }
    appSaveDiscoverPreference(data: SendPreferenceCRMData): void {
        this.jsbridge.appSaveDiscoverPreference(data);
    }
    appOpenRacingLiveStream(): void {
        this.jsbridge.appOpenRacingLiveStream();
        nonPageTracker({ eventID: TrackingEvent.VideoPlay });
    }
    appOpenNativePlayer(url: string, title: string, isPip: boolean): void {
        this.jsbridge?.appOpenNativePlayer(url, title || '', isPip);
    }
    appOpenMsLiveStream(): void {
        this.jsbridge.appOpenMsLiveStream();
    }
    appOnLeavePreferencePage(): void {
        this.jsbridge?.appOnLeavePreferencePage();
    }
    // addCalendarEvent(
    //     title: string,
    //     description: string,
    //     eventUUID: string,
    //     startTime: number,
    //     endTime: number
    // ): void {
    //     this.jsbridge?.addCalendarEvent(title, description, eventUUID, startTime, endTime);
    // }
    addCalendarEvent(
        title: string,
        description: string,
        eventUUID: string,
        startTime: number,
        endTime: number
    ): Promise<{ eventUUID: string; result: boolean }> {
        return handleJsBridgePromise(() =>
            this.jsbridge?.addCalendarEvent(title, description, eventUUID, startTime, endTime)
        );
    }

    setAllBettingStrategies(value: boolean) {
        this.jsbridge?.setAllBettingStrategies(value);
    }
}

interface CalendarEventResponse {
    eventUUID: string;
    result: boolean;
}

export function handleJsBridgePromise<T extends CalendarEventResponse>(
    jsBridgeCall: () => Promise<T>
): Promise<T> {
    return new Promise((resolve, reject) => {
        jsBridgeCall()
            .then((response) => {
                if (response && response.result) {
                    resolve(response); // 成功时解析 Promise
                } else {
                    reject(new Error('Failed to add calendar event')); // 自定义错误
                }
            })
            .catch((error) => {
                reject(error); // 捕获和拒绝错误
            });
    });
}
